import { Model } from './model';

export const ROLE_OWNER_ID = 'ROLE_OWNER';
export const ROLE_ADMIN_ID = 'ROLE_ADMIN';
export class Role extends Model {
  id: string;
  operations?: any;
}
